export const SELECT = 'SELECT_DIET';
export const REMOVE = 'REMOVE_DIET';
export const DEFAULT = 'DEFAULT_DIET';
export const FETCH_DATA_PENDING = 'FETCH_DATA_PENDING_DIET';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS_DIET';
export const FETCH_DATA_ERROR = 'FETCH_DATA_ERROR_DIET';

export function fetchDataPending() {
  return {
    type: FETCH_DATA_PENDING
  }
}

export function fetchDataSuccess(data) {
  return {
    type: FETCH_DATA_SUCCESS,
    data: data
  }
}

export function fetchDataError(error) {
  return {
    type: FETCH_DATA_ERROR,
    error: error
  }
}
